import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useZxing } from 'react-zxing';

import Modal from 'Components/Globals/Elements/Modal/loadable';
import overlay from 'Assets/images/walletPayment/overlay.svg';
import Loading from 'Components/Globals/Loading/loadable';
import loading from 'Assets/images/payment/loading.gif';
import ConfirmExitModal from '../ConfirmExitModal';
import routes from 'Pages/router/constants/routes';
import { SAGA_REQUEST_KEY } from 'Constants';
import { composeClassNames } from 'Helpers';
import useContent from 'Hooks/useContent';
import {
	generalSelectors,
	walletPaymentTypes,
	walletPaymentActions,
	walletPaymentSelectors,
} from 'Ducks';

import styles from './styles.module.scss';
import strings from './strings';

const BarcodeScanner = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { formatMessage } = useContent();

	const [hasCalledAPI, setHasCalledAPI] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [insufficientBox, setInsufficientBox] = useState(false);

	const id = useSelector(walletPaymentSelectors.selectTransactionId);
	const error = useSelector(walletPaymentSelectors.selectBarcodeError);
	const isLoading = useSelector((state) =>
		generalSelectors.selectApiLoadingStatus(
			state,
			walletPaymentTypes.CHECK_BARCODE.REQUEST
		)
	);

	const { ref } = useZxing({
		onDecodeResult(result) {
			const scannedBarcode = result.getText();
			if (!hasCalledAPI) {
				handleBarcodeScan(scannedBarcode);
				insufficientBox(false);
				setHasCalledAPI(true);
			}
		},
	});

	const handleBarcodeScan = (barcodeData) => {
		if (!barcodeData) return;
		dispatch(
			walletPaymentActions.checkBarcodeRequest({
				id,
				barcode: barcodeData,
				navigate,
				[SAGA_REQUEST_KEY.DISABLE_TOAST]: true,
			})
		);
	};

	useEffect(() => {
		if (error) {
			if (error === formatMessage(strings.insufficient)) {
				setInsufficientBox(true);
				setHasCalledAPI(false);
			} else {
				navigate(routes.transactionStatus);
			}
		}
	}, [error, navigate, formatMessage]);

	return (
		<div className={styles.wrapper}>
			{insufficientBox ? (
				<div
					className={composeClassNames([
						'p-16 m-16',
						styles.wrapper__insufficient,
					])}
				>
					<img
						className={styles.wrapper__image}
						src={loading}
						alt='loading'
					/>
					<p>{formatMessage(strings.insufficient)}</p>
				</div>
			) : (
				<p
					className={composeClassNames([
						'mt-24 text-center txt-white m-16',
						styles.wrapper__description,
					])}
				>
					{formatMessage(strings.description)}
				</p>
			)}
			<div className={styles.wrapper__camera}>
				<video
					ref={ref}
					className={styles.wrapper__camera}
					muted
					autoPlay
				></video>
			</div>
			<img
				className={styles.wrapper__frame}
				src={overlay}
				alt='frame'
			/>
			{isLoading && (
				<div className={styles.wrapper__loading}>
					<Loading />
				</div>
			)}
			<div className={styles.wrapper__button}>
				<p
					onClick={() => navigate(routes.manualBarcode)}
					className={composeClassNames([
						'mh-16 text-center pv-16 sm txt-white',
						styles.wrapper__button__action,
						styles.wrapper__button__with_border,
					])}
				>
					{formatMessage(strings.manualButton)}
				</p>
				<p
					onClick={() => setShowModal(true)}
					className={composeClassNames([
						'mt-4 mh-16 text-center pv-16 sm txt-white',
						styles.wrapper__button__action,
					])}
				>
					{formatMessage(strings.exitButton)}
				</p>
			</div>
			<Modal
				bottomSheet
				onClose={() => setShowModal(false)}
				show={showModal}
				title={formatMessage(strings.modalTitle)}
				className='modal-zIndex bold txt-dark lg'
			>
				<ConfirmExitModal onClose={() => setShowModal(false)} />
			</Modal>
		</div>
	);
};

export default BarcodeScanner;
